<template>
<div class="vliveComment bgc box-shadow">
    <vliveHeader :item="item"></vliveHeader>
    <div class="padding-20 info-box">
        <div class="classes blod">官方主持人</div>
        <div class="sponsor-info">
            <div class="left">
                <img :src="item.mplogoPic.furl === '' ? require('@/common/images/other/head_icon.png') : item.mplogoPic.furl +'?'+timestamp" alt="">
            </div>
            <div class="right">
                <div><span class="sponsor-name">{{item.openmpname === '' ? '主持人' : item.openmpname}}</span><label class="sponsor-label">官方</label></div>
                <div><el-button class="btn" type="text" size="small" @click="handleOpenHostEdit">修改</el-button></div>
            </div>
        </div>
        <div class="form page-form send-message">
            <el-input v-model.trim="comment"></el-input>
            <el-button type="primary" @click="addComment">发送</el-button>
        </div>
        <div class="classes blod comment-title">
            <span class="blod">观众评论</span>
            <span class="switch"  @click.stop="switchStatus">人工审核未开启<el-switch v-model="item.iscommentaudit" disabled></el-switch></span>
        </div>
        <div class="vlive-box">
            <div class="result-list btn-operate-list" v-show="item.iscommentaudit">
                <div class="table-title">未审核</div>
                <el-table :data="tableData" style="width: 100%" :show-header="false" @select="selected" ref="multipleTable">
                    <el-table-column type="selection" width="30"></el-table-column>
                    <el-table-column label="报告标题">
                        <template slot-scope="scope">
                            <div class="imageText">
                                <!-- <img src="https://f10.baidu.com/it/u=2706660451,701816488&fm=72" alt=""> -->
                                <!-- <img v-if="scope.row.isOfficial == 1" :src="item.mplogoPic.furl === '' ? require('@/common/images/other/head_icon.png') : item.mplogoPic.furl +'?'+timestamp" alt=""> -->
                                <img :src="scope.row.headimageurl" alt="">
                                <div class="imageText-summary">
                                    <div>
                                        <!-- <span v-if="scope.row.isOfficial == 1" class="name">{{item.openmpname === '' ? '主持人' : item.openmpname}}</span> -->
                                        <span class="name">{{scope.row.customername}}</span>
                                        <label v-if="scope.row.isOfficial == 1" class="sponsor-label">官方</label>
                                        <span style="margin-left: 10px;" class="tc-grey">{{scope.row.datetime}}</span>
                                    </div>
                                    <div class="tc-grey">{{scope.row.content}}</div>
                                </div>
                            </div>
                            <div class="tr">
                                <el-button @click="handleContentPass(scope.row)" size="small">通过</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="btn-operate">
                    <el-checkbox v-model="checked" @change="checkedAll">全选</el-checkbox>
                    <el-button type="primary" @click="pass">批量通过</el-button>
                </div>
                <!--<page :total="total" @getList="_getList"></page>-->
                <el-pagination background @current-change="_getList" :current-page.sync="page.page" :page-size="page.pageSize"
                               :pager-count="11" layout="prev, pager, next" :total="total">
                </el-pagination>
            </div>
            <div class="result-list btn-operate-list">
                <div class="table-title"  v-show="item.iscommentaudit">已审核</div>
                <el-table :data="tableAuditedData" style="width: 100%" :show-header="false">
                    <el-table-column label="报告标题">
                        <template slot-scope="scope">
                            <div class="imageText">
                                <!-- <img src="https://f10.baidu.com/it/u=2706660451,701816488&fm=72" alt=""> -->
                                <img :src="scope.row.headimageurl" alt="">
                                <div class="imageText-summary">
                                    <div>
                                        <span class="name">{{scope.row.customername}}</span>
                                        <label  v-if="scope.row.isOfficial == 1" class="sponsor-label">官方</label>
                                        <span style="margin-left: 10px;" class="tc-grey">{{scope.row.datetime}}</span>
                                    </div>
                                    <div class="tc-grey">{{scope.row.content}}</div>
                                </div>
                            </div>
                            <div class="tr">
                                <el-button @click="handleContentDel(scope.row)" size="small">删除</el-button>
                                <el-button @click="handleContentForbidden(scope.row)" size="small">禁言</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="btn-operate"></div>
                <el-pagination background @current-change="_getAuditedList" :current-page.sync="tableAuditedPage.page" :page-size="tableAuditedPage.pageSize"
                               :pager-count="11" layout="prev, pager, next" :total="tableAuditedtotal">
                </el-pagination>
            </div>
        </div>
    </div>
    <vliveHostEdit ref="vliveHostEdit" @setHostInfo="_setHostInfo"></vliveHostEdit>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import VliveHeader from 'views/cms/vlive/components/vliveHeader'
import VliveHostEdit from 'views/cms/vlive/components/vliveHostEdit'
import {getVliveCommentAuditList, addVliveComment, editVliveCommentAuditStatus, editVliveCommentStatus, getVliveCommentAuditedList,
    getVliveSponsorInfo, editVliveWeChatFollow, editVliveCommentForbidden} from 'api/api'
import {formatFileInfo} from 'common/js/tools'
import {vliveMsg} from 'api/message'
export default {
    name: 'vliveComment',
    data() {
        return {
            timestamp: new Date().getTime(), // 时间戳
            checked: false,
            comment: '',
            kmcinnerid: this.$route.query.id ? this.$route.query.id : '', // id
            item: {
                customerinnerid: '', // 官方会员ID
                openmpname: '', // 官方公众号名称
                mplogoPic: {
                    bucket: '',
                    fname: '',
                    fsize: '',
                    width: '',
                    height: '',
                    key: '',
                    mimeType: '',
                    objecttype: '',
                    furl: ''
                },
                iscommentaudit: true // 评论是否要人工审核
            },
            tableData: [],
            tableAuditedData: [],
            page: {
                page: 1,
                pageSize: 10
            },
            total: 0,
            tableAuditedtotal: 0,
            tableAuditedPage: {
                page: 1,
                pageSize: 10
            },
            selectedResult: []
        }
    },
    mounted() {
        this._getSponsorInfo()
        this._getList()
        // this._getAuditedList()
    },
    methods: {
        // 编辑主持人
        handleOpenHostEdit() {
            let obj = {
                name: this.item.openmpname,
                fileInfo: this.item.mplogoPic
            }
            this.$refs.vliveHostEdit.openDialog(obj)
        },
        // 保存主持人信息
        _setHostInfo(name, file) {
            this.timestamp = new Date().getTime()
            this.setLoading(true)
            editVliveWeChatFollow({
                data: {
                    assetinnerid: this.kmcinnerid,
                    openmpname: name,
                    coverPicture: formatFileInfo(file)
                },
                success: data => {
                    this.$message.success(vliveMsg.submitHostInfo.successMsg)
                    this.item.openmpname = name
                    this.item.mplogoPic = file
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 通过评论
        handleContentPass(row) {
            let idList = [row.innerid].join(',')
            this.$confirm(vliveMsg.passContent.msg, vliveMsg.passContent.title, {
                confirmButtonText: vliveMsg.passContent.confirmText,
                cancelButtonText: vliveMsg.passContent.cancelText
            }).then(() => {
                let status = 10
                this._editStatus(idList, status, vliveMsg.passContent.successMsg)
            }).catch(() => {})
        },
        // 删除评论
        handleContentDel(row) {
            let idList = [row.innerid].join(',')
            this.$confirm(vliveMsg.delContent.msg, vliveMsg.delContent.title, {
                confirmButtonText: vliveMsg.delContent.confirmText,
                cancelButtonText: vliveMsg.delContent.cancelText
            }).then(() => {
                let status = 100
                this._editStatus(idList, status, vliveMsg.delContent.successMsg)
            }).catch(() => {})
        },
        // 禁言
        handleContentForbidden(row) {
            this.$confirm(vliveMsg.forbiddenContent.msg, vliveMsg.forbiddenContent.title, {
                confirmButtonText: vliveMsg.forbiddenContent.confirmText,
                cancelButtonText: vliveMsg.forbiddenContent.cancelText
            }).then(() => {
                this._forbiddenComment(row.innerid)
            }).catch(() => {})
        },
        // 选择评论
        selected(selection, row) {
            this.selectedResult = selection
            // this.$refs.multipleTable.toggleRowSelection(row)
            if (selection.length === this.tableData.length) {
                this.checked = true
            } else {
                this.checked = false
            }
        },
        // 选择所有评论
        checkedAll() {
            this.$refs.multipleTable.toggleAllSelection(this.checked)
            if (this.checked) {
                this.selectedResult = this.tableData
            } else {
                this.selectedResult = []
            }
        },
        // 批量通过评论
        pass() {
            let status = 10
            let idList = []
            this.selectedResult.forEach(obj => {
                idList.push(obj.innerid)
            })
            idList = idList.join(',')
            this.$confirm(vliveMsg.submitSomeStatus.msg, vliveMsg.submitSomeStatus.title, {
                confirmButtonText: vliveMsg.submitSomeStatus.confirmText,
                cancelButtonText: vliveMsg.submitSomeStatus.cancelText
            }).then(() => {
                this._editStatus(idList, status, vliveMsg.submitSomeStatus.successMsg)
            }).catch(() => {})
        },
        // 发布评论
        addComment() {
            if (this.comment) {
                this._addComment()
            } else {
                this.$alert('请输入评论内容', '提示', {
                    dangerouslyUseHTMLString: true
                })
            }
        },
        _forbiddenComment (innerid) {
            this.setLoading(true)
            editVliveCommentForbidden({
                data: Object.assign({}, {innerid: innerid}),
                success: data => {
                    this.setLoading(false)
                    this.$message.success(vliveMsg.forbiddenContent.cancelText)
                    this._getAuditedList()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _addComment() {
            this.setLoading(true)
            addVliveComment({
                data: Object.assign({}, {kmcinnerid: this.kmcinnerid, kmctype: '3', content: this.comment}),
                success: data => {
                    this.setLoading(false)
                    this.comment = ''
                    this._getList()
                    this._getAuditedList()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 开启/关闭人工审核
        switchStatus() {
            this.$confirm(vliveMsg.checkStatus.msg, vliveMsg.checkStatus.title, {
                confirmButtonText: vliveMsg.checkStatus.confirmText,
                cancelButtonText: vliveMsg.checkStatus.cancelText
            }).then(() => {
                let status = !this.item.iscommentaudit ? '1' : '0'
                let tip = ''
                if (status) {
                    tip = '开启人工审核成功'
                } else {
                    tip = '关闭人工审核成功'
                }
                this._editAuthStatus(status, tip)
            })
        },
        // 审核通过  删除
        _editStatus(innerid, status, tip) {
            this.setLoading(true)
            editVliveCommentStatus({
                data: Object.assign({}, {innerid: innerid, status: status}),
                success: data => {
                    this.setLoading(false)
                    this.$message.success(tip)
                    this._getList()
                    this._getAuditedList()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 开启/关闭人工审核
        _editAuthStatus(status, tip) {
            this.setLoading(true)
            editVliveCommentAuditStatus({
                data: Object.assign({}, {innerid: this.kmcinnerid, iscommentaudit: status}),
                success: data => {
                    this.item.iscommentaudit = !this.item.iscommentaudit
                    this.setLoading(false)
                    this.$message.success(tip)
                    // this._getList()
                    this._getAuditedList()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 获取主持人信息  是否开启人工审核状态
        _getSponsorInfo() {
            getVliveSponsorInfo({
                data: Object.assign({}, {innerid: this.kmcinnerid}),
                success: data => {
                    data.data.iscommentaudit = data.data.iscommentaudit === 1
                    this.item = data.data
                    this.setLoading(false)
                    // if (this.item.iscommentaudit) {
                    //     this._getAuditedList()
                    // }
                    this._getAuditedList()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 获取未审核的列表   没有开启人工审核的列表
        _getList() {
            this.setLoading(true)
            getVliveCommentAuditList({
                data: Object.assign({}, {kmcinnerid: this.kmcinnerid, kmctype: '3'}, this.page),
                success: data => {
                    this.tableData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 获取审核通过的列表
        _getAuditedList() {
            this.setLoading(true)
            getVliveCommentAuditedList({
                data: Object.assign({}, {kmcinnerid: this.kmcinnerid, kmctype: '3'}, this.tableAuditedPage),
                success: data => {
                    this.tableAuditedData = data.data.content
                    this.tableAuditedtotal = data.data.pageinfo.rowCount
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'loading'
        ])
    },
    components: {
        VliveHeader,
        VliveHostEdit
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.vliveComment {
    box-sizing: border-box;
    .info-box{
        width: 1020px;
    }
    .label{
        background: $bgcolor-base;
        border-radius: 9px;
        color: $tcolor-white;
        font-size: $font-12;
        padding: 3px 6px;
    }
    .sponsor-info{
        .el-button, .el-button--mini{
            min-width: auto;
        }
        @include flexBox(flex-start);
        .left{
            width: 50px;
            height: 50px;
            margin-right: 15px;
            img{
                width: 100%;
                height: 100%;
            }
        }
        .right{
            .sponsor-label{
                margin-left: 20px;
                @extend .label;
                border-radius: 20px;
            }
        }
    }
    .send-message{
        margin-bottom: 20px;
        box-sizing: border-box;
        @include flexBox(space-between);
        .el-button, .el-button--mini{
            margin-left: 20px;
        }
    }
    .comment-title{
        margin-top: 40px;
        @include flexBox(space-between);
        .switch{
            font-size: $font-14;
            .el-switch{
                margin-left: 10px;
            }
            color: $tcolor-gray;
        }
    }
    .vlive-box{
        @include flexBox(space-between);
        align-items: flex-start;
        .result-list{
            flex-grow: 1;
            width: 50%;
            .table-title{
                height: 54px;
                background: $bgcolor-lightgrey;
                font-size: $font-16;
                line-height: 54px;
                text-align: center;
                border-bottom: 1px solid $line;
            }
            .el-table__row{
                max-height: 70px;
                .el-table-column--selection{
                    padding: 0 0 32px 0;
                }
            }
            .imageText{
                .name{
                    font-size: $font-14;
                    margin-right: 20px;
                }
                .sponsor-label{
                    @extend .label;
                }
                img{
                    width: 50px;
                    height: 50px;
                    border-radius: 50%;
                }
            }
            .btn-operate{
                @include flexBox(space-between);
                height: 60px;
                padding: 20px 12px 0 12px;
            }
        }
    }
    .btn-operate-list .el-button {
        width: 96px;
        height: 32px;
        padding: auto;
    }
    .el-switch.is-disabled{
        opacity: 1;
    }
    .el-switch.is-disabled .el-switch__core, .el-switch.is-disabled .el-switch__label{
        cursor: pointer;
    }
    .el-pagination{
        margin-top: 20px;
        text-align: center;
    }
    .page{
        margin-top: 0;
    }
}
</style>
